import { render, staticRenderFns } from "./TablePatents.vue?vue&type=template&id=0fe2bbca"
import script from "./TablePatents.vue?vue&type=script&lang=js"
export * from "./TablePatents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports